import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-192e87e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-text" }, " Sont Auditeurs, ceux qui participent par une présence active à tous les cours. Ils ne se soumettent ni aux devoirs ni aux examens. A la fin de leur formation, ils ont une attestation d’auditeurs. ")
  ])
], -1))
const _hoisted_4 = { class: "row g-4" }
const _hoisted_5 = { class: "prof-mini-card" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "prof-mini-name" }
const _hoisted_9 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiants, (etu) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-3 col-md-4 col-sm-6",
            key: etu.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              (etu.user?.urlImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getImageUrl(etu.user.urlImage),
                    alt: "Photo disciple",
                    class: "prof-photo"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.defaultPhoto,
                    alt: "Photo par défaut",
                    class: "prof-photo"
                  }, null, 8, _hoisted_7)),
              _createElementVNode("h5", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: `/disciplesEmmaius/${etu.id}`,
                  class: "prof-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(etu.nom) + " " + _toDisplayString(etu.prenom), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}